@if (isPackageLoading()) {
  <div class="h-full flex items-center justify-center">
    <app-loading-spinner withLogo size="large"></app-loading-spinner>
  </div>
} @else {
  <div class="sidebar-wrapper" animate.enter="animate-fade-in">
    <div class="sidebar-header flex items-center justify-between">
      <div class="flex items-center gap-2">
        <div class="text-size_3xl font-semibold text-navy-900">{{ submittalPackage()?.package_name }}</div>
        <app-options-list-simple [actions]="menuOptions()" (optionSelected)="onMenuOptionSelected($event)">
        </app-options-list-simple>
      </div>
      <div
        class="action-required-box"
        [class]="{
          'border-yellow-450': submittalPackage()?.action_required,
          'border-navy-300': !submittalPackage()?.action_required,
        }"
      >
        <span class="label">
          @if (submittalPackage()?.action_required) {
            ACTION REQUIRED
          } @else {
            NO ACTION REQUIRED
          }
        </span>
        <span
          class="icon icon-exclamation-box-filled text-[24px]"
          [class]="{
            'text-yellow-450': submittalPackage()?.action_required,
            'text-navy-300': !submittalPackage()?.action_required,
          }"
        ></span>
      </div>
    </div>
    <div class="main-content mx-5 mt-0 p-0 flex flex-col">
      <app-underline-tabs [tabs]="tabs()" [(selectedTab)]="selectedTab"></app-underline-tabs>

      <div class="package-header">
        <div>
          <div class="text-size_xxl font-semibold">{{ submittalPackage()?.title }}</div>
          <div class="text-size_m font-normal overflow-hidden text-ellipsis flex gap-1">
            <span class="font-semibold">{{ submittalPackage()?.project?.custom_project_id }}</span>
            <span>{{ submittalPackage()?.project?.title }}</span>
          </div>
        </div>
        <div class="mr-[28px]">
          <app-status-block [status]="submittalPackage()?.status" size="medium"></app-status-block>
        </div>
      </div>

      @if (selectedTab() === TAB_OPTION.PACKAGE_DETAILS) {
        <app-submittal-package-details-tab class="tab-component"></app-submittal-package-details-tab>
      }

      @if (selectedTab() === TAB_OPTION.SUBMITTALS) {
        <app-submittal-package-submittals-tab class="tab-component"></app-submittal-package-submittals-tab>
      }

      @if (selectedTab() === TAB_OPTION.DISCUSSIONS) {
        <div class="package-content discussions">
          <div class="column details participants">
            @for (company of submittalCompanies(); track company.company_name) {
              <app-expansion-panel-v2 class="company-expansion-panel" [expanded]="isExpanded()[company.company_name]">
                <div (click)="toggleCompanyExpand(company)" header-row class="company-header">
                  @if (isExpanded()[company.company_name]) {
                    <span class="icon icon-collapse-square"></span>
                  } @else {
                    <span class="icon icon-expand-square"></span>
                  }
                  <span class="company-name">{{ company.company_name }}</span>
                </div>
                <div content-row>
                  @for (user of company.users; track $index) {
                    <div class="company-user">
                      <span class="empty-box"></span>
                      <span class="flex flex-col">
                        <span class="text-size_l font-semibold">{{ user.name }}</span>
                        <span class="text-size_s">{{ user.company_name }}</span>
                      </span>
                    </div>
                  }
                </div>
              </app-expansion-panel-v2>
            }
          </div>
          <div class="discussions-column">
            @if (selectedMessagingView() === MESSAGING_VIEWS().DISCUSSION_THREAD_VIEW) {
              <app-discussion-thread-view class="flex-1 min-h-0"></app-discussion-thread-view>
            } @else {
              <app-discussions-view [hideHeader]="true" class="flex-1 min-h-0"></app-discussions-view>
            }
          </div>
        </div>
      }

      @if (selectedTab() !== TAB_OPTION.DISCUSSIONS) {
        <div class="version-box">
          <span [appTooltip]="hasLowerVersion() ? 'Previous version' : 'No lower version'" tooltipPosition="top">
            <span
              (click)="changeVersion(-1)"
              class="icon-rounded-triangle left"
              [class]="{ invalid: !hasLowerVersion() }"
            ></span>
          </span>
          <span class="version-text">VERSION {{ version() }}</span>
          <span [appTooltip]="hasHigherVersion() ? 'Next version' : 'No higher version'" tooltipPosition="top">
            <span
              (click)="changeVersion(+1)"
              class="icon-rounded-triangle right"
              [class]="{ invalid: !hasHigherVersion() }"
            ></span>
          </span>
        </div>
      }
    </div>
  </div>
}
